import { createGlobalStyle } from 'styled-components'
import { PancakeTheme } from '@pancakeswap/uikit'

declare module 'styled-components' {
  /* eslint-disable @typescript-eslint/no-empty-interface */
  export interface DefaultTheme extends PancakeTheme { }
}

const GlobalStyle = createGlobalStyle`
  * {
    font-family: 'Poppins', sans-serif;
  }
  body {
    background: ${({ theme }) => theme.colors.background}; 
  
    /* background: url('/images/background.jpg') 50% / cover no-repeat #191919; */
    img {
      height: auto;
      max-width: 100%;
    }
  }

  .to-orange-950\/20:is(.dark *) {
    --tw-gradient-to: #44130633;
  }

  .professional-card {
    border: 2px solid #3f3f47;
  }
  .border-zinc-700 {
    border: 2px solid #3f3f47;
  }

  @keyframes marquee {
    0% { transform: translateX(100%); }
    100% { transform: translateX(-100%); }
  }

  .animate-marquee {
    display: inline-flex;
    animation: marquee 60s linear infinite; /* adjust speed */
  }
`

export default GlobalStyle
